import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, Row, Col } from 'reactstrap';
import CurrencyFormat from 'react-currency-format';

const priceTooltip = props => {
  return (
    <React.Fragment>
      <span id={`pricing-${props.index}`} className={'pointer ml-2'}>
        <FontAwesomeIcon icon={['fas', 'info-circle']} />
      </span>
      <Tooltip
        placement="bottom"
        isOpen={props.tooltipOpen === `pricing-${props.index}`}
        delay={0}
        target={`pricing-${props.index}`}
        toggle={() => props.toggleTooltip(`pricing-${props.index}`)}
      >
        <div className={'p-2 text-left font-xs'} style={{ width: '190px' }}>
          <div className={'color-red'}>
            {props.title !== undefined ? props.title : 'Breakdown'}
          </div>
          {props.fees.map((cost, index) => {
            return (
              <Row className={'d-flex'} key={index}>
                <Col xs={6}>{cost.name}</Col>
                <Col xs={6}>
                  <CurrencyFormat
                    value={cost.amount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </Col>
              </Row>
            );
          })}
          {props.items !== undefined &&
            props.items.map((item, index) => {
              return (
                <Row className={'d-flex'} key={index}>
                  <Col xs={12}>{item}</Col>
                </Row>
              );
            })}
        </div>
      </Tooltip>
    </React.Fragment>
  );
};
export default priceTooltip;



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Pricing/PricingRow/PriceTooltip/PriceTooltip.jsx